import { Entity } from '@backstage/catalog-model';

const CLOUDBUILD_LOCATION_ANNOTATION = 'google.com/cloudbuild-location';

/** @public */

export const getLocation = (entity: Entity) => {
  const locationAnnotation =
    entity?.metadata.annotations?.[CLOUDBUILD_LOCATION_ANNOTATION] ?? '';
  if (locationAnnotation) {
    return locationAnnotation;
  }
  return 'global';
};
